import Api from "~/service/Api";

class SubscriptionEventRepository {
  fetch(query = {}) {
    return Api.get("/subscription-events", query);
  }
}

export default SubscriptionEventRepository;
